// src/store/index.js
import { createStore } from 'vuex';

// 创建一个 store 实例
const store = createStore({
    // state 就像是管理中心的仓库，用来存放共享的数据
    state() {
        return {
            menuList: [],
            banner: "",
        };
    },
    // mutations 就像是仓库的管理员，专门负责修改 state 里的数据
    mutations: {
        storageList(state, menuList) {
            state.menuList = menuList
        },
        storageImage(state, banner) {
            state.banner = banner
        }
    },
    // actions 就像是商场的调度员，它可以处理一些异步操作，然后再调用 mutations 来修改数据
    actions: {
        incrementAsync(context) {
            setTimeout(() => {
                context.commit('increment');  // 过 1 秒后调用 increment 这个 mutation
            }, 1000);
        },
        async loginAsync(context, userData) {
            // 模拟一个异步的登录请求
            const response = await fetch('/api/login', {
                method: 'POST',
                body: JSON.stringify(userData)
            });
            if (response.ok) {
                context.commit('login', userData);
            }
        }
    },
    // getters 就像是商场的查询台，组件可以通过它来获取 state 里的数据
    getters: {
        getMenuList(state) {
            return state.menuList;  // 返回计数器值的两倍
        }
    }
});

export default store;
